import { ListSortDirection, Sort } from "../../models/api/sort";
import { EmployeeAddressDTO } from "../../models/employee-addresses";
import { EmployeeAddressSTO } from "../../models/employee-addresses";
import { EmployeeAddressesFilter } from "../../models/employee-addresses/employee-addresses-filter";
import { BaseApiService } from "../base/base-api.service";

export class EmployeesAddressesApiService extends BaseApiService<EmployeeAddressDTO, EmployeeAddressSTO> {
  constructor() {
    super({
      servicePath: "/EmployeesAddresses",
      loadItemsPath: "/GetEmployeesAddresses",
      saveItemsPath: "/SaveEmployeesAddresses",
    });
    this.defaultSort = [
      {
        name: "employee.firstName",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "employee.lastName",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "region",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "locality",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "addressLine1",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadEmployeesAddresses = async (employeeId: string, forManager: boolean, signal?: AbortSignal) => {
  const apiService = new EmployeesAddressesApiService();
  if (!forManager) {
    apiService.useLoadItemsPath("/GetCurrentUserEmployeesAddresses");
  }

  const response = await apiService.loadItems(
    !forManager
      ? ({ employeeId } as EmployeeAddressesFilter)
      : ({ employeeIds: [employeeId] } as EmployeeAddressesFilter),
    "",
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  return response;
};
